import type { CreditsResponse } from '@/types/monetization';

/**
 * Extract total credits from a credits response, handling both SDK formats.
 */
const getTotalCredits = (response: CreditsResponse): number => {
  const info = response.creditsInfo ?? response.creditInfo;
  if (!info) return 0;
  return (info.credits ?? 0) + (info.addonCredits ?? 0);
};

export default getTotalCredits;
